export const replacePII = message => {
  if (!message) {
    return '';
  }
  return message.replace(/[\w\.\+\-]+@([\w-]+\.)+[\w-]{2,4}/g, '[EMAIL]').replace(/[0-9]/g, '[X]');
};
//# sourceMappingURL=replacePii.js.map